import { NodeType } from "ngx-core-services";

export const ENERGY_UNIT = 'kWh';
export const IRRADIATION_ENERGY_UNIT = 'kWh/m²';
export const IRRADIATION_SERIES_NAME = 'SOL_EG';
export const SECONDARY_UNIT_SERIES = [IRRADIATION_SERIES_NAME] as const;

export const getChartLegendByNodeSelection = (nodeSelected: NodeType[]) => ({
  P_DC_TOT: nodeSelected.includes('solar'),
  P_EXP: nodeSelected.includes('grid'),
  P_LOAD: nodeSelected.includes('home'),
  P_B_AGGR: nodeSelected.includes('battery'),
  EG1: nodeSelected.includes('solar'),
  EG2: nodeSelected.includes('grid'),
  EG3: nodeSelected.includes('grid'),
  EG4: nodeSelected.includes('home'),
  EG5: nodeSelected.includes('battery'),
  EG6: nodeSelected.includes('battery'),
  SOL_EG: nodeSelected.includes('irradiance'),
});

export const labels = {
  Jan: 'Jan',
  Feb: 'Feb',
  Mar: 'Mar',
  Apr: 'Apr',
  May: 'May',
  Jun: 'Jun',
  Jul: 'Jul',
  Aug: 'Aug',
  Sep: 'Sep',
  Oct: 'Oct',
  Nov: 'Nov',
  Dec: 'Dec',
  loading: 'Loading energies...',
  title: 'Energy resume',
  month: 'Month',
  year: 'Year',
  statisticsAvg: 'Avg',
  statisticsMax: 'Max',
  statisticsMin: 'Min',
  statisticsTotal: 'Total',
  statisticsBatteryTitle: 'Battery',
  statisticsConsumedTitle: 'Consumed',
  statisticsGeneratedTitle: 'Generated',
  statisticsGridTitle: 'Grid',
  statisticsChargeSubtitle: 'Charge',
  statisticsDischargeSubtitle: 'Discharge',
  statisticsExportSubtitle: 'Export',
  statisticsImportSubtitle: 'Import',
  statisticsIrradiationTitle: 'Irradiation',
  noDataForTheSelectedPeriod: 'No data for the selected period',
  todayModeEnabled: 'Today mode enabled',
};

export const DEFAULT_TELEMETRY_MODE = 'month' as const;
